module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABF0lEQVQ4T6XTMUrEQBQG4P9FhV1IseCCFjYLFusZtFjB0sYJFh5BPcTiGRaT0hOIYLEKFtrZeIAV7BQMiAgWO4Ek+2QGJk4msTCZ9n//x/CGIRHKOxAPM/b2rk86z7COCOUjAf0UtO9mZoyCSL4C2ABznMIb2YMimn8QqF+X/QKT7yGWVu5BWHcHD87nO55HNwD8vxBSUtAC0UAbpACaIiWgCVIBKgjw9hl3Bg9nlKmsvFi81AIiSreJs1sQfACzy+PultmVkz1VALcsF/nu9NSPFVCXlYD/lhVcAE3K6lYaaFrWQJuyBoJQvut/AMzshY3GvLy6lnyZl7Az+8eSiOQFGJsJ54dm28WThckVEffkIj9yMzPzA/x8InWqCA/3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/newLoginPage/icon2.png
// module id = rGYq
// module chunks = 96